import React from 'react';
import VisitDetails from './Components/VisitDetails';

const VisitDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <VisitDetails />
      </div>
    </div>
  );
};

export default VisitDetailsPage;
